import moment from 'moment-timezone';

import {
  getPrimaryColor,
  getSecondaryColor
} from '@/shared/components/core-ui/color-picker/color-picker.component';
import { MemberCommissionResponse } from '@/shared/models/teams.model';
import { MemberCommissionTableUIModel } from '@/shared/ui-models/teams.ui-model';

function mapToUi(teamMember: MemberCommissionResponse): {
  data: MemberCommissionTableUIModel[];
  totalCount: number;
} {
  const groupedByDateRoleTeam: { [key: string]: MemberCommissionTableUIModel } = {};

  teamMember?.commissions?.forEach((commission) => {
    const {
      month,
      year,
      role,
      team,
      kpi,
      monthlyTarget,
      teamMonthlyTarget,
      commission: commissionStatus
    } = commission;

    // Create a unique groupId that includes team IDs to separate entries with different teams
    const teamIds = team?.map((t) => t.id ?? '') ?? '';

    const groupId = `${month}_${year}_${role}_${teamIds}`;

    if (!groupedByDateRoleTeam[groupId]) {
      groupedByDateRoleTeam[groupId] = {
        id: groupId,
        date: moment({ year: year, month: month - 1 }).format('MMM YYYY'),
        role,
        commission: commissionStatus,
        performance: [],
        teamPerformance: [],
        team: team?.map((t) => t.name ?? '') ?? []
      };
    }

    groupedByDateRoleTeam[groupId].performance?.push({
      kpiName: kpi?.name ?? '',
      metricType: kpi?.metricType ?? '',
      value: commission.totalAchievedTargetCount,
      maxValue: monthlyTarget,
      primaryColor: getPrimaryColor(kpi?.color ?? '') ?? '',
      secondryColor: getSecondaryColor(kpi?.color ?? '') ?? ''
    });

    groupedByDateRoleTeam[groupId].teamPerformance?.push({
      kpiName: kpi?.name ?? '',
      metricType: kpi?.metricType ?? '',
      value: commission.teamTotalAchievedTargetCount,
      maxValue: teamMonthlyTarget,
      primaryColor: getPrimaryColor(kpi?.color ?? '') ?? '',
      secondryColor: getSecondaryColor(kpi?.color ?? '') ?? ''
    });
  });

  const data = Object.values(groupedByDateRoleTeam).sort((a, b) => {
    return moment(b.date, 'MMM YYYY').valueOf() - moment(a.date, 'MMM YYYY').valueOf();
  });

  return {
    data,
    totalCount: teamMember.total_count
  };
}

const salesMemberCommissionTableMapper = { mapToUi };

export default salesMemberCommissionTableMapper;
